import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Checkbox,
  TextField,
  Box,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function PriorityEmailTableAccordion({ form, setForm }) {
const companies = ["דוח חניון חודשי","דוח חניון יומי"];
  // console.log(form);
  // const isSelected = (name) => form.priorityRecords?.filter(pr=>pr.companyName===name)[0]?.isPriority === 1;
  // console.log(isSelected);
  // const isSendEmail = (name) => form.priorityRecords?.map(pr=>pr.companyName).includes(name);

  const getRec = (company) =>
      form.priorityRecords?.find(r => r.companyName === company)
      ?? { companyName: company, isPriority: 0, sendEmail: 0, email: "" };

  // helper to either update an existing rec, or append a new one
  const setRec = (company, changes) =>
      setForm(prev => {
        const found = prev.priorityRecords?.some(r => r.companyName === company);
        const updated = found
            ? prev.priorityRecords.map(r =>
                r.companyName === company ? { ...r, ...changes } : r
            )
            : [...(prev.priorityRecords||[]), { ...getRec(company), ...changes }];
        return { ...prev, priorityRecords: updated };
      });

  const togglePriority = (company) => {
    const { isPriority } = getRec(company);
    setRec(company, { isPriority: isPriority === 1 ? 0 : 1 });
  };
  const toggleSendEmail = (company) => {
    const { sendEmail } = getRec(company);
    setRec(company, { sendEmail: sendEmail === 1 ? 0 : 1 });
  };
  const updateEmail = (company, email) =>
      setRec(company, { email });



  return (
    <Accordion
      defaultExpanded
      sx={{
        backgroundColor: "#1e1e30",
        border: "1px solid #fff",
        borderRadius: 1,
        p: 0,
        m: 0,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 36 }}>
        <Typography
          fontWeight="medium"
          fontSize="0.9rem"
          color="#ccc"
          sx={{ width: "100%", textAlign: "left" }}
        >
          הגדרות פריוריטי
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        {/* Header Row */}
        <Grid container item spacing={1} sx={{ px: 1 }}>
          <Grid item xs={12} sm={3}>
            <Typography sx={{ color: "#90caf9", fontWeight: "bold", fontSize: "0.75rem" }}>
              תבנית
            </Typography>
          </Grid>
          <Grid item xs={3} sm={2}>
            <Typography sx={{ color: "#90caf9", fontWeight: "bold", fontSize: "0.75rem" }}>
              פריוריטי
            </Typography>
          </Grid>
          <Grid item xs={9} sm={6}>
            <Typography sx={{ color: "#90caf9", fontWeight: "bold", fontSize: "0.75rem" }}>
              אימייל
            </Typography>
          </Grid>
        </Grid>

        {/* Data Rows */}
        {companies.map((company) =>{
          const rec = getRec(company);
            return (
          <Grid
            container
            item
            key={company}
            spacing={1}
            alignItems="center"
            sx={{ px: 1, py: 0.5, borderBottom: "1px solid #333" }}
          >
            <Grid item xs={12} sm={3}>
              <Typography sx={{ color: "#fff", fontSize: "0.8rem" }}>{company}</Typography>
            </Grid>

            <Grid item xs={3} sm={2}>
              <Checkbox
                  checked={rec.isPriority === 1}
                  onChange={() => togglePriority(company)}
                  sx={{ color: "#90caf9" }}
              />
            </Grid>
            <Grid item xs={9} sm={7}>
              <Box display="flex" alignItems="center" gap={1}>
                <Checkbox
                    checked={rec.sendEmail === 1}
                    onChange={() => toggleSendEmail(company)}
                    sx={{ color: "#90caf9" }}
                />
                <TextField
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="example@email.com"
                    value={rec.email}
                    onChange={e => updateEmail(company, e.target.value)}
                    disabled={rec.sendEmail !== 1}
                    inputProps={{ style: { direction: "ltr", fontSize: "0.75rem" } }}
                    sx={{ input: { bgcolor: "#2b2b3c", color: "white", borderRadius: 2 } }}
                />
              </Box>
            </Grid>

          </Grid>
            )     }
        )}
      </AccordionDetails>
    </Accordion>
  );
}
